import React from 'react';

export default class EESTable extends React.Component {
    render() {
        return (
            <table className="configuration-editor-output-table configuration-editor-ees-table">
                <thead>
                <tr>
                    <th>{__('Category')}</th>
                    <th>{__('Points')}</th>
                </tr>
                </thead>

                <tbody>
                {this.props.items.map((c, idx) => (
                    <tr key={idx}>
                        <td>{c.category}</td>
                        <td>{c.currentPoints} / {c.maximumPoints}</td>
                    </tr>
                ))}
                </tbody>
            </table>
        )
    }
}